 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		64: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		64: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors/components/about/components/base-business-contact/components/base-business-info/components/d/a8aaf134","2":"vendors/components/base-contact-form/components/base-text-field/components/base-textarea/components//610a617a","3":"vendors/components/base-business-contact/components/base-business-info/components/keep-in-touch/page/a02a5765","4":"vendors/components/base-contact-form/components/base-text-field/components/base-textarea/components//967b8097","5":"vendors/components/about/pages/about/pages/index/pages/people/_slug","6":"vendors/components/data-iterator/pages/alternatives/index/pages/portfolio/pages/tools/index","7":"components/about","10":"components/base-avatar","11":"components/base-avatar-card","12":"components/base-body","13":"components/base-btn","14":"components/base-business-contact","15":"components/base-business-info","16":"components/base-contact-form","17":"components/base-divider","18":"components/base-heading","19":"components/base-info-card","20":"components/base-section","21":"components/base-section-heading","22":"components/base-subheading","23":"components/base-subtitle","24":"components/base-text-field","25":"components/base-textarea","26":"components/base-title","27":"components/base-tooltip-button","28":"components/blog-card","29":"components/blog-hero","30":"components/breadcrumb","31":"components/card-group","32":"components/column","33":"components/contact-us","34":"components/data-iterator","35":"components/feature","36":"components/features","37":"components/grid","38":"components/hero","39":"components/keep-in-touch","40":"components/lean-canvas","41":"components/location-button","42":"components/mailgo","43":"components/price-range","44":"components/services","45":"components/teaser","46":"pages/about","47":"pages/alternatives/index","48":"pages/blog/_slug","49":"pages/blog/index","50":"pages/contact","51":"pages/features","52":"pages/index","53":"pages/lean-canvas","54":"pages/people/_slug","55":"pages/people/index","56":"pages/pitches/_slug","57":"pages/pitches/index","58":"pages/portfolio","59":"pages/releases","60":"pages/services/index","61":"pages/tools/_slug","62":"pages/tools/index","63":"pages/value-based-pricing-canvas","66":"vendors/components/base-contact-form","67":"vendors/content/plugin.js","68":"vendors/pages/people/_slug","69":"vendors/pages/people/index","70":"vendors/pages/services/index","71":"vendors/pages/tools/_slug"}[chunkId]||chunkId) + ".js?v=" + {"0":"e32dce5","1":"10023ef","2":"01f0746","3":"9fbc480","4":"31f3d76","5":"86684b5","6":"a70400b","7":"e73a370","10":"310565e","11":"eb379ec","12":"d97fd89","13":"2636cce","14":"c9ced21","15":"ba340d4","16":"6412f6e","17":"1e82528","18":"80ac0e9","19":"301c6e2","20":"680962d","21":"a430ff7","22":"d2da520","23":"c4833af","24":"0ef9c0a","25":"94596c8","26":"d70696b","27":"89d256c","28":"227d285","29":"2a3a5ba","30":"ceec963","31":"eac9747","32":"7c31542","33":"241a8ce","34":"a6e1cd8","35":"f0f65fc","36":"e56e1a1","37":"a75f6b8","38":"da6fbb1","39":"a2ebc6e","40":"bb3db98","41":"f9feddb","42":"6a6464a","43":"2b13ade","44":"18af299","45":"7942718","46":"d48404a","47":"08a3af5","48":"d06f6db","49":"a852fca","50":"b049b81","51":"f4f6fcc","52":"4ede6d7","53":"e3fa007","54":"8cb0072","55":"58d369c","56":"b781fcd","57":"54b5e11","58":"ea120ff","59":"6379c31","60":"38bb97b","61":"f000945","62":"1f2d54c","63":"df8bb5b","66":"8957458","67":"8cb97ab","68":"32df377","69":"6538805","70":"d0e4c3a","71":"4cf7f81","72":"df88fa3","73":"8a62c48","74":"4453743"}[chunkId] + ""
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// extract-css-chunks-webpack-plugin CSS loading
 		var supportsPreload = (function() { try { return document.createElement("link").relList.supports("preload"); } catch(e) { return false; }}());
 		var cssChunks = {"2":1,"6":1,"25":1,"29":1,"30":1,"39":1,"40":1,"46":1,"47":1,"48":1,"49":1,"50":1,"51":1,"53":1,"54":1,"55":1,"56":1,"57":1,"58":1,"59":1,"60":1,"61":1,"62":1,"66":1,"68":1,"69":1,"70":1,"71":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"0":"vendors/components/about/components/base-business-contact/components/base-business-info/components/d/a8aaf134","2":"vendors/components/base-contact-form/components/base-text-field/components/base-textarea/components//610a617a","3":"vendors/components/base-business-contact/components/base-business-info/components/keep-in-touch/page/a02a5765","4":"vendors/components/base-contact-form/components/base-text-field/components/base-textarea/components//967b8097","5":"vendors/components/about/pages/about/pages/index/pages/people/_slug","6":"vendors/components/data-iterator/pages/alternatives/index/pages/portfolio/pages/tools/index","7":"components/about","10":"components/base-avatar","11":"components/base-avatar-card","12":"components/base-body","13":"components/base-btn","14":"components/base-business-contact","15":"components/base-business-info","16":"components/base-contact-form","17":"components/base-divider","18":"components/base-heading","19":"components/base-info-card","20":"components/base-section","21":"components/base-section-heading","22":"components/base-subheading","23":"components/base-subtitle","24":"components/base-text-field","25":"components/base-textarea","26":"components/base-title","27":"components/base-tooltip-button","28":"components/blog-card","29":"components/blog-hero","30":"components/breadcrumb","31":"components/card-group","32":"components/column","33":"components/contact-us","34":"components/data-iterator","35":"components/feature","36":"components/features","37":"components/grid","38":"components/hero","39":"components/keep-in-touch","40":"components/lean-canvas","41":"components/location-button","42":"components/mailgo","43":"components/price-range","44":"components/services","45":"components/teaser","46":"pages/about","47":"pages/alternatives/index","48":"pages/blog/_slug","49":"pages/blog/index","50":"pages/contact","51":"pages/features","52":"pages/index","53":"pages/lean-canvas","54":"pages/people/_slug","55":"pages/people/index","56":"pages/pitches/_slug","57":"pages/pitches/index","58":"pages/portfolio","59":"pages/releases","60":"pages/services/index","61":"pages/tools/_slug","62":"pages/tools/index","63":"pages/value-based-pricing-canvas","66":"vendors/components/base-contact-form","67":"vendors/content/plugin.js","68":"vendors/pages/people/_slug","69":"vendors/pages/people/index","70":"vendors/pages/services/index","71":"vendors/pages/tools/_slug"}[chunkId]||chunkId) + ".css?v=" + {"0":"31d6cfe","1":"31d6cfe","2":"0ff0564","3":"31d6cfe","4":"31d6cfe","5":"31d6cfe","6":"f716bb9","7":"31d6cfe","10":"31d6cfe","11":"31d6cfe","12":"31d6cfe","13":"31d6cfe","14":"31d6cfe","15":"31d6cfe","16":"31d6cfe","17":"31d6cfe","18":"31d6cfe","19":"31d6cfe","20":"31d6cfe","21":"31d6cfe","22":"31d6cfe","23":"31d6cfe","24":"31d6cfe","25":"8918760","26":"31d6cfe","27":"31d6cfe","28":"31d6cfe","29":"d64cccd","30":"d64cccd","31":"31d6cfe","32":"31d6cfe","33":"31d6cfe","34":"31d6cfe","35":"31d6cfe","36":"31d6cfe","37":"31d6cfe","38":"31d6cfe","39":"d538e4d","40":"5b90093","41":"31d6cfe","42":"31d6cfe","43":"31d6cfe","44":"31d6cfe","45":"31d6cfe","46":"d64cccd","47":"d64cccd","48":"d64cccd","49":"d64cccd","50":"d538e4d","51":"d64cccd","52":"31d6cfe","53":"f143073","54":"eba9b4e","55":"eba9b4e","56":"d64cccd","57":"d64cccd","58":"d64cccd","59":"8522636","60":"eba9b4e","61":"eba9b4e","62":"d64cccd","63":"31d6cfe","66":"1d1256d","67":"31d6cfe","68":"f284970","69":"733d9c7","70":"733d9c7","71":"733d9c7","72":"31d6cfe","73":"31d6cfe","74":"31d6cfe"}[chunkId] + "";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if((tag.rel === "stylesheet" || tag.rel === "preload") && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = supportsPreload ? "preload": "stylesheet";
 				supportsPreload ? linkTag.as = "style" : linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0]; head.appendChild(linkTag)
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 				if(supportsPreload) {
 					var execLinkTag = document.createElement("link");
 					execLinkTag.href =  __webpack_require__.p + "css/" + ({"0":"vendors/components/about/components/base-business-contact/components/base-business-info/components/d/a8aaf134","2":"vendors/components/base-contact-form/components/base-text-field/components/base-textarea/components//610a617a","3":"vendors/components/base-business-contact/components/base-business-info/components/keep-in-touch/page/a02a5765","4":"vendors/components/base-contact-form/components/base-text-field/components/base-textarea/components//967b8097","5":"vendors/components/about/pages/about/pages/index/pages/people/_slug","6":"vendors/components/data-iterator/pages/alternatives/index/pages/portfolio/pages/tools/index","7":"components/about","10":"components/base-avatar","11":"components/base-avatar-card","12":"components/base-body","13":"components/base-btn","14":"components/base-business-contact","15":"components/base-business-info","16":"components/base-contact-form","17":"components/base-divider","18":"components/base-heading","19":"components/base-info-card","20":"components/base-section","21":"components/base-section-heading","22":"components/base-subheading","23":"components/base-subtitle","24":"components/base-text-field","25":"components/base-textarea","26":"components/base-title","27":"components/base-tooltip-button","28":"components/blog-card","29":"components/blog-hero","30":"components/breadcrumb","31":"components/card-group","32":"components/column","33":"components/contact-us","34":"components/data-iterator","35":"components/feature","36":"components/features","37":"components/grid","38":"components/hero","39":"components/keep-in-touch","40":"components/lean-canvas","41":"components/location-button","42":"components/mailgo","43":"components/price-range","44":"components/services","45":"components/teaser","46":"pages/about","47":"pages/alternatives/index","48":"pages/blog/_slug","49":"pages/blog/index","50":"pages/contact","51":"pages/features","52":"pages/index","53":"pages/lean-canvas","54":"pages/people/_slug","55":"pages/people/index","56":"pages/pitches/_slug","57":"pages/pitches/index","58":"pages/portfolio","59":"pages/releases","60":"pages/services/index","61":"pages/tools/_slug","62":"pages/tools/index","63":"pages/value-based-pricing-canvas","66":"vendors/components/base-contact-form","67":"vendors/content/plugin.js","68":"vendors/pages/people/_slug","69":"vendors/pages/people/index","70":"vendors/pages/services/index","71":"vendors/pages/tools/_slug"}[chunkId]||chunkId) + ".css?v=" + {"0":"31d6cfe","1":"31d6cfe","2":"0ff0564","3":"31d6cfe","4":"31d6cfe","5":"31d6cfe","6":"f716bb9","7":"31d6cfe","10":"31d6cfe","11":"31d6cfe","12":"31d6cfe","13":"31d6cfe","14":"31d6cfe","15":"31d6cfe","16":"31d6cfe","17":"31d6cfe","18":"31d6cfe","19":"31d6cfe","20":"31d6cfe","21":"31d6cfe","22":"31d6cfe","23":"31d6cfe","24":"31d6cfe","25":"8918760","26":"31d6cfe","27":"31d6cfe","28":"31d6cfe","29":"d64cccd","30":"d64cccd","31":"31d6cfe","32":"31d6cfe","33":"31d6cfe","34":"31d6cfe","35":"31d6cfe","36":"31d6cfe","37":"31d6cfe","38":"31d6cfe","39":"d538e4d","40":"5b90093","41":"31d6cfe","42":"31d6cfe","43":"31d6cfe","44":"31d6cfe","45":"31d6cfe","46":"d64cccd","47":"d64cccd","48":"d64cccd","49":"d64cccd","50":"d538e4d","51":"d64cccd","52":"31d6cfe","53":"f143073","54":"eba9b4e","55":"eba9b4e","56":"d64cccd","57":"d64cccd","58":"d64cccd","59":"8522636","60":"eba9b4e","61":"eba9b4e","62":"d64cccd","63":"31d6cfe","66":"1d1256d","67":"31d6cfe","68":"f284970","69":"733d9c7","70":"733d9c7","71":"733d9c7","72":"31d6cfe","73":"31d6cfe","74":"31d6cfe"}[chunkId] + "";
 					execLinkTag.rel = "stylesheet";
 					execLinkTag.type = "text/css";
 					document.body.appendChild(execLinkTag);
 				}
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/_nuxt/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
